<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import axios from 'axios';
import DataTable from 'datatables.net-vue3';
import moment from 'moment';
import { usePermissions } from '@/composables/usePermissions';

export default {
  page: {
    title: "Role",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      role: localStorage.getItem('role'),
      title: "User List/External Users",
      items: [
        { text: "User", href: "/" },
        { text: "External Users", active: true },
      ],
      country_: '',
      mine: '',
      country: [],
      IDUser_: '',
      Submenu: '',
      ListUser: [],
      channelpartnerlist: [],
      programList: [],
      DetailUser: [],
      branchList: [],
      rawBranchList: [],
      loadingDetail: false,
      loadingRoles: true,
      ButtonSeen: true,
      channel_partner_id: '',
      program_id: '',
      branch_id: '',
      email: '',
      fullname: '',
      password: '',
      confirm_password: '',
      user_id: '',
      is_active: 1,
      isTelco: false,
      showPassword: false,
      showPassword2: false,
    };
  },
  setup() {
    const {
      canReadExternalUser,
      permissions,
      canUpdateExternalUser,
      canExportExternalUser,
      canCreateExternalUser,
      canDeleteExternalUser
    } = usePermissions();

    return {
      canReadExternalUser,
      permissions,
      canUpdateExternalUser,
      canExportExternalUser,
      canDeleteExternalUser,
      canCreateExternalUser
    };
  },
  methods: {
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    toggleShow2() {
      this.showPassword2 = !this.showPassword2;
    },
    format_date(value) {
      if (value) {
        return moment(String(value)).format('YYYY-MM-DD HH:mm:ss');
      }
    },
    downloadExcel() {
      location.href = process.env.VUE_APP_API_BASEURL + 'users/export';
    },
    getListUser() {
      axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt');
      axios.get(process.env.VUE_APP_API_BASEURL + 'externalUser/list')
        .then(response => {
          if (response) {
            this.loadingRoles = false;
            this.ListUser = response.data;
          } else {
            this.messageBag = ['No record.'];
          }
        })
        .catch(error => {
          this.messageBag = [error.error];
        });
    },
    getUserDetails(uid) {
      this.ButtonSeen = true;
      this.loadingDetail = true;
      axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt');
      axios.get(process.env.VUE_APP_API_BASEURL + 'externalUser/userDetails/' + uid)
        .then(response => {
          if (response) {
            this.DetailUser = response.data;
            this.user_id = this.DetailUser[0].id;
            this.fullname = this.DetailUser[0].staff_name;
            this.email = this.DetailUser[0].email;
            this.channel_partner_id = this.DetailUser[0].channelpartner_id;
            this.branch_id = this.DetailUser[0].branch_id;
            this.program_id = this.DetailUser[0].program_id;
            this.is_active = this.DetailUser[0].is_active;
            this.isTelco = this.DetailUser[0].is_telco;
            this.loadingDetail = false;
          } else {
            this.messageBag = ['No record.'];
          }
        })
        .catch(error => {
          this.messageBag = [error.error];
        });
    },
    DeleteUser(uid) {
      this.user_id = uid;
    },
    confirmDeleteUser(e) {
      e.preventDefault();
      const posting_ = { user_id: this.user_id };
      axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt');
      axios.post(process.env.VUE_APP_API_BASEURL + 'externalUser/deleteExternaluser', posting_)
        .then(response => {
          if (response) {
            alert(response.data.msj);
            this.$router.go(this.$router.currentRoute);
          } else {
            console.log('ada problem');
          }
        });
    },
    createExternalUser(e) {
      if (this.confirm_password == this.password) {
        e.preventDefault();
        const posting_ = {
          name: this.fullname,
          email: this.email,
          password: this.password,
          program_id: this.program_id,
          channel_partner_id: this.channel_partner_id,
        };
        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt');
        axios.post(process.env.VUE_APP_API_BASEURL + 'externalUser/createExternalUser', posting_)
          .then(response => {
            if (response) {
              document.getElementById("createNewUser").reset();
              alert(response.data.msj);
              this.$router.go(this.$router.currentRoute);
            } else {
              this.ButtonSeen = false;
              console.log('tak ok');
            }
          });
      } else {
        e.preventDefault();
        alert('Password Not Match!');
      }
    },
    updateExternalUser(e) {
      if (this.password != '') {
        if (this.confirm_password != this.password) {
          e.preventDefault();
          alert('Password Not Match!');
          return;
        }
      }
      this.ButtonSeen = true;
      e.preventDefault();
      const posting_ = {
        user_id: this.user_id,
        name: this.fullname,
        email: this.email,
        program_id: this.program_id,
        channel_partner_id: this.channel_partner_id,
        branch_id: this.branch_id,
        is_active: this.is_active,
        is_telco: this.isTelco,
      };
      if (this.password != '') {
        posting_.password = this.password;
      }
      axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt');
      axios.post(process.env.VUE_APP_API_BASEURL + 'externalUser/updateExternalUser', posting_)
        .then(response => {
          if (response) {
            this.ButtonSeen = false;
            alert(response.data.msj);
          } else {
            this.ButtonSeen = false;
            console.log('tak ok');
          }
        });
    },
    selectChannelPartner() {
      axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt');
      axios.get(process.env.VUE_APP_API_BASEURL + 'externalUser/getBranchListByChannelPartner/' + this.channel_partner_id)
        .then(response => {
          if (response) {
            this.branchList = response.data;
          } else {
            alert('No branch data found');
          }
        })
        .catch(error => {
          this.messageBag = [error.error];
        });

      axios.get(process.env.VUE_APP_API_BASEURL + 'externalUser/getProgramByChannelPartner/' + this.channel_partner_id)
        .then(response => {
          if (response) {
            this.programListData = response.data;
          } else {
            alert('No program data found');
          }
        })
        .catch(error => {
          this.messageBag = [error.error];
        });
    },
    get_channel_partner() {
      axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt');
      axios.get(process.env.VUE_APP_API_BASEURL + 'channelpartner/raw_data')
        .then(response => {
          if (response) {
            this.channelpartnerlist = response.data;
          } else {
            this.messageBag = ['No record.'];
          }
        })
        .catch(error => {
          this.messageBag = [error.error];
        });
    },
    get_program() {
      axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt');
      axios.get(process.env.VUE_APP_API_BASEURL + 'program/raw_data')
        .then(response => {
          if (response) {
            this.programList = response.data;
          } else {
            this.messageBag = ['No record.'];
          }
        })
        .catch(error => {
          this.messageBag = [error.error];
        });
    },
    getBranchList() {
      axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt');
      axios.get(process.env.VUE_APP_API_BASEURL + 'branch/list')
        .then(response => {
          if (response) {
            this.rawBranchList = response.data;
          } else {
            this.messageBag = ['No record.'];
          }
        })
        .catch(error => {
          this.messageBag = [error.error];
        });
    },
  },
  components: {
    Layout,
    PageHeader,
    DataTable,
  },
  mounted() {
    this.getListUser();
    this.get_channel_partner();
    this.get_program();
    this.getBranchList();
  },
};

require("@/assets/css/datatable.css");
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="d-flex justify-content-end mb-3">
      <div class="d-flex justify-content-end mb-3" v-if="canExportExternalUser">
        <button @click="downloadExcel()" class="btn btn-success">
          <i class="ri-file-excel-2-line align-middle me-1"></i> Export Excel
        </button>
        <router-link to="/user/create-ext-users" custom v-slot="{ navigate }">
          <button class="btn btn-primary ms-1" @click="navigate" role="link" v-if="canCreateExternalUser">
            <i class="ri-add-line align-middle me-1"></i> Add New User
          </button>
        </router-link>
      </div>
    </div>

    <div class="card" v-if="canReadExternalUser">
      <div class="card-body">
        <div class="live-preview">
          <div class="row align-items-center g-12">
            <div class="col-lg-12">
              <div v-if="loadingRoles">
                <div class="spinner-border text-success" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
              <div v-else>
                <div class="table-responsive">
                  <DataTable class="table table-striped table-nowrap mb-0">
                    <thead class="table-secondary">
                      <tr>
                        <th>No.</th>
                        <th scope="col">Name</th>
                        <th scope="col">Referral Code</th>
                        <th scope="col">Email</th>
                        <th scope="col">Channel Partner</th>
                        <th scope="col">Branch Name</th>
                        <th scope="col">Program</th>
                        <th scope="col">Status</th>
                        <th scope="col">Date Created</th>
                        <th scope="col">Created By</th>
                        <th scope="col">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in ListUser" :key="index" class="content">
                        <td>{{ index + 1 }}</td>
                        <td>{{ item.staff_name }}</td>
                        <td>
                          <span v-if="item.ref_code" class="badge bg-info">{{ item.ref_code }}</span>
                          <span v-else class="text-muted">—</span>
                        </td>
                        <td>{{ item.email }}</td>
                        <td>{{ item.partnername }}</td>
                        <td>{{ item.branchname }}</td>
                        <td>{{ item.program_name }}</td>
                        <td v-if="item.is_active == 1">
                          <span class="badge bg-success">Active</span>
                        </td>
                        <td v-else>
                          <span class="badge bg-danger">Disabled</span>
                        </td>
                        <td>{{ format_date(item.created_at) }}</td>
                        <td>{{ item.created_by }}</td>
                        <td>
                          <i v-if="canUpdateExternalUser"
                             @click="getUserDetails(item.id)"
                             class="ri-eye-fill"
                             data-bs-toggle="modal"
                             data-bs-target=".bs-example-modal-lg"></i>
                          &nbsp;
                          <i v-if="canDeleteExternalUser"
                             @click="DeleteUser(item.id)"
                             class="ri-delete-bin-5-fill"
                             data-bs-toggle="modal"
                             data-bs-target=".deleteUser"></i>
                        </td>
                      </tr>
                    </tbody>
                  </DataTable>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="text-center text-muted p-4">
      You do not have permission to view Users.
    </div>

    <!-- ===================== EDIT USER MODAL ===================== -->
    <div class="modal fade bs-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalgridLabel">Edit User</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form @submit="updateExternalUser" id="updateExternalUser">
              <div class="row g-3">
                <div class="col-xxl-12">
                  <label for="firstName" class="form-label">Full Name <span class="text-danger">*</span></label>
                  <input type="text" v-model="fullname" class="form-control" id="firstName" placeholder="Enter Full Name" required />
                  <input type="hidden" v-model="user_id" class="form-control" id="userid" />
                </div>

                <div class="col-xxl-12">
                  <label for="emailInput" class="form-label">Email <span class="text-danger">*</span></label>
                  <input type="email" class="form-control" id="emailInput" v-model="email" placeholder="Enter email" required />
                </div>

                <div class="col-xxl-12">
                  <label class="form-label">Channel Partner <span class="text-danger">*</span></label>
                  <select v-model="channel_partner_id" class="form-select mb-3" @change="selectChannelPartner" required>
                    <option value="">--- Select Channel Partner ---</option>
                    <option v-for="(item, index) in channelpartnerlist" :key="index" :value="item.id">
                      {{ item.name }}
                    </option>
                  </select>
                </div>

                <div class="col-xxl-12">
                  <label class="form-label">Branch <span class="text-danger">*</span></label>
                  <select v-model="branch_id" class="form-select mb-3" required>
                    <option value="">--- Select Branch ---</option>
                    <option v-for="(item, index) in rawBranchList" :key="index" :value="item.id">
                      {{ item.name }}
                    </option>
                  </select>
                </div>

                <div class="col-xxl-12">
                  <label class="form-label">Program <span class="text-danger">*</span></label>
                  <select v-model="program_id" class="form-select mb-3" required>
                    <option value="">--- Select Program ---</option>
                    <option v-for="(item, index) in programList" :key="index" :value="item.id">
                      {{ item.program_name }}
                    </option>
                  </select>
                </div>

                <div class="col-xxl-12">
                  <label for="passwordInput" class="form-label">Password</label>
                  <div class="input-group">
                    <input v-if="showPassword2" type="text" class="form-control" v-model="password" />
                    <input v-else type="password" class="form-control" v-model="password" placeholder="**********" />
                    <a class="button" @click="toggleShow2">
                      <span class="input-group-text">
                        <i :class="{ 'ri-eye-off-line': showPassword2, 'ri-eye-line': !showPassword2 }"></i>
                      </span>
                    </a>
                  </div>
                </div>

                <div class="col-xxl-12">
                  <label for="passwordInput" class="form-label">Confirm Password</label>
                  <div class="input-group">
                    <input v-if="showPassword" type="text" class="form-control" v-model="confirm_password" />
                    <input v-else type="password" class="form-control" v-model="confirm_password" placeholder="**********" />
                    <a class="button" @click="toggleShow">
                      <span class="input-group-text">
                        <i :class="{ 'ri-eye-off-line': showPassword, 'ri-eye-line': !showPassword }"></i>
                      </span>
                    </a>
                  </div>
                </div>

                <div class="col-md-6">
                  <label class="form-label">is Telco</label>
                  <div class="list-group">
                    <label class="list-group-item">
                      <input class="form-check-input fs-14 mt-0 align-middle me-1" name="is_telco" v-model="isTelco" type="radio" :value="1" />
                      Active
                    </label>
                    <label class="list-group-item">
                      <input class="form-check-input fs-14 mt-0 align-middle me-1" name="is_telco" v-model="isTelco" type="radio" :value="0" />
                      Disabled
                    </label>
                  </div>
                </div>

                <div class="col-md-6">
                  <label class="form-label">Status</label>
                  <div class="list-group">
                    <label class="list-group-item">
                      <input class="form-check-input fs-14 mt-0 align-middle me-1" name="status" v-model="is_active" type="radio" value="1" />
                      Active
                    </label>
                    <label class="list-group-item">
                      <input class="form-check-input fs-14 mt-0 align-middle me-1" name="status" v-model="is_active" type="radio" value="0" />
                      Disabled
                    </label>
                  </div>
                </div>

                <div class="col-lg-12">
                  <div class="hstack gap-2 justify-content-end">
                    <button type="button" class="btn btn-light" data-bs-dismiss="modal">Close</button>
                    <button type="submit" class="btn btn-primary">Submit</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- ===================== ADD NEW USER MODAL (legacy) ===================== -->
    <div class="modal fade" id="exampleModalgrid" tabindex="-1" aria-labelledby="exampleModalgridLabel">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalgridLabel">Add New User</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form @submit="createExternalUser" id="createNewUser">
              <div class="row g-3">
                <div class="col-xxl-12">
                  <label class="form-label">Full Name <span class="text-danger">*</span></label>
                  <input type="text" v-model="fullname" class="form-control" placeholder="Enter Full Name" required />
                </div>
                <div class="col-xxl-12">
                  <label class="form-label">Email <span class="text-danger">*</span></label>
                  <input type="email" class="form-control" v-model="email" placeholder="Enter email" required />
                </div>
                <div class="col-xxl-12">
                  <label class="form-label">Channel Partner <span class="text-danger">*</span></label>
                  <select v-model="channel_partner_id" class="form-select mb-3" required>
                    <option value="">--- Select Channel Partner ---</option>
                    <option v-for="(item, index) in channelpartnerlist" :key="index" :value="item.id">
                      {{ item.name }}
                    </option>
                  </select>
                </div>
                <div class="col-xxl-12">
                  <label class="form-label">Program <span class="text-danger">*</span></label>
                  <select v-model="program_id" class="form-select mb-3" required>
                    <option value="">--- Select Program ---</option>
                    <option v-for="(item, index) in programList" :key="index" :value="item.id">
                      {{ item.program_name }}
                    </option>
                  </select>
                </div>
                <div class="col-xxl-12">
                  <label class="form-label">Password <span class="text-danger">*</span></label>
                  <input type="password" class="form-control" v-model="password" placeholder="**********" required />
                </div>
                <div class="col-xxl-12">
                  <label class="form-label">Confirm Password <span class="text-danger">*</span></label>
                  <input type="password" class="form-control" v-model="confirm_password" placeholder="**********" required />
                </div>
                <div class="col-lg-12">
                  <div class="hstack gap-2 justify-content-end">
                    <button type="button" class="btn btn-light" data-bs-dismiss="modal">Close</button>
                    <button type="submit" class="btn btn-primary">Submit</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- ===================== DELETE CONFIRMATION ===================== -->
    <div class="modal fade bs-example-modal-center deleteUser" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body text-center p-5">
            <form @submit="confirmDeleteUser" id="confirmDeleteUser">
              <div class="mt-4">
                <h4 class="mb-3">Are you sure want to remove this user?</h4>
                <input type="hidden" class="form-control" v-model="user_id" />
                <div class="hstack gap-2 justify-content-center">
                  <button type="button" class="btn btn-light" data-bs-dismiss="modal">Close</button>
                  <button type="submit" class="btn btn-danger">Remove</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

  </Layout>
</template>